import React, { createContext, useContext, useEffect, useState } from 'react';
import { getMe, login as apiLogin,logout as logoutApi} from '../api/authApi';

interface AuthContextType {
  user: any;
  loading: boolean;
  login: (credentials: { username: string; password: string }) => Promise<void>;
  logout: () => void;
  hasPermission: (permission: string) => boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true); // ✅ new state

  const login = async ({ username, password }: { username: string; password: string }) => {
    await apiLogin(username, password);
    const me = await getMe();
    setUser(me);
  };
  const hasPermission = (permission: string): boolean => {
    if (!user) return false;

    const allPermissions = user.role?.permissions?.map((p: any) => p.name) || [];
    return allPermissions.includes(permission);
  }
  const logout = () => {
    setUser(null);
    logoutApi()
      .then(() => {
        setUser(null);
      })
      .catch((error) => {
        console.error('Logout failed:', error);
      });
  };

  useEffect(() => {
    getMe()
      .then((me) => setUser(me))
      .catch(() => setUser(null))
      .finally(() => setLoading(false)); // ✅ stop loading even if failed
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be inside AuthProvider");
  return context;
};
